import { apiClient } from './client.js';

export const analyticsApi = {
  getDashboardStats: () => apiClient.get('/analytics/dashboard'),
};
